import { Pipe, PipeTransform } from '@angular/core'
import { Product } from '@app-domains/content-blocks/components/product-card/product-card.types'
import {
    ImageFragment,
    ParagraphFragment,
    ProductImageFragment,
    UniqueSellingPointFragment,
    VideoFragment,
} from '@app-graphql/schema'
import { DealerHit } from '@app-types/dealer.types'
import { PageHit } from '@app-types/page.types'

export class AsTypePipe<T> implements PipeTransform {
    transform(value: unknown, asArray: true): T[]
    transform(value: unknown, asArray: false): T
    transform(value: unknown): T
    transform(value: unknown, asArray?: boolean): T | T[] {
        if (asArray) {
            return value as T[]
        }
        return value as T
    }
}

@Pipe({
    name: 'asProduct',
    standalone: false,
})
export class AsProductPipe extends AsTypePipe<Product> implements PipeTransform {}

@Pipe({
    name: 'asUspFragment',
    standalone: false,
})
export class AsUspFragmentPipe extends AsTypePipe<UniqueSellingPointFragment> implements PipeTransform {}

@Pipe({
    name: 'asParagraphFragment',
    standalone: false,
})
export class AsParagraphFragmentPipe extends AsTypePipe<ParagraphFragment> implements PipeTransform {}

@Pipe({
    name: 'asVideoFragment',
    standalone: false,
})
export class AsVideoFragmentPipe extends AsTypePipe<VideoFragment> implements PipeTransform {}

@Pipe({
    name: 'asProductImageFragment',
    standalone: false,
})
export class AsProductImageFragmentPipe extends AsTypePipe<ProductImageFragment> implements PipeTransform {}

@Pipe({
    name: 'asImageFragment',
    standalone: false,
})
export class AsImageFragmentPipe extends AsTypePipe<ImageFragment> implements PipeTransform {}

@Pipe({
    name: 'asDealerHit',
    standalone: false,
})
export class AsDealerHitPipe extends AsTypePipe<DealerHit> implements PipeTransform {}

@Pipe({
    name: 'asPageHit',
    standalone: false,
})
export class AsPageHitPipe extends AsTypePipe<PageHit> implements PipeTransform {}
